import Immutable from 'immutable'

export const TokenRecord = Immutable.Record({
  access_token: null,
  expires_in: 3600,
  token_type: 'bearer',
}, 'Token')

export default function createToken(data) {
  return new TokenRecord(data)
}




// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Token.js